import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Box from '@material-ui/core/Box'
import Alert from '@material-ui/lab/Alert'
import CircularProgress from '@material-ui/core/CircularProgress'
import DropdownMenu from '../../components/reuseable/DropdownMenu'
import Button from '@material-ui/core/Button'
import { MODAL_TITLE, MODAL_DESCRIPTION, SELECT_USER_LABEL } from './constants'

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContent: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    width: '500px',
    maxWidth: '90vw',
    outline: 'none',
  },
  modalTitle: {
    marginBottom: theme.spacing(3),
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  modalActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  modalDropdown: {
    '& .dropdown_menu': {
      '& Button': {
        color: theme.palette.text.primary + ' !important',
        backgroundColor: theme.palette.background.default + ' !important',
        border: `1px solid ${theme.palette.divider} !important`,
        width: '100% !important',
        justifyContent: 'flex-start !important',
        '&:hover': {
          backgroundColor: theme.palette.action.hover + ' !important',
        },
      },
      '& .label': {
        color: theme.palette.text.primary + ' !important',
        fontSize: '14px !important',
      },
    },
  },
}))

const CreateAliasUserModal = ({
  createModalOpen,
  handleCloseCreateModal,
  selectedOrganization,
  hiMarleyUsers,
  hiMarleyUsersError,
  createAliasUserError,
  isLoadingHiMarleyUsers,
  selectedHiMarleyUser,
  isSubmittingCreateUser,
  handleSubmitCreateUser,
  handleDropdownSelection,
}) => {
  const classes = useStyles()
  const renderModalContent = () => {
    const modalContentStyles = { display: 'flex', justifyContent: 'center', margin: '16px 0' }
    if (isLoadingHiMarleyUsers) {
      return (
        <div style={modalContentStyles}>
          <CircularProgress size={24} />
          <span style={{ marginLeft: '8px' }}>Loading users...</span>
        </div>
      )
    }
    if (isSubmittingCreateUser) {
      return (
        <div style={modalContentStyles}>
        <CircularProgress size={24} />
      </div>
      )
    }
    return (
      <DropdownMenu
        selected={selectedHiMarleyUser}
        setSelected={handleDropdownSelection}
        items={hiMarleyUsers}
        label={SELECT_USER_LABEL}
        className="menu"
      />
    )
  }

  const error = hiMarleyUsersError || createAliasUserError

  return (
    <Modal
        open={createModalOpen}
        onClose={handleCloseCreateModal}
        className={classes.modal}
        aria-labelledby="create-alias-user-modal-title"
        aria-describedby="create-alias-user-modal-description"
      >
        <Box className={classes.modalContent}>
          <div className={classes.modalTitle} id="create-alias-user-modal-title">
            {MODAL_TITLE}
          </div>
          <div id="create-alias-user-modal-description">
            {MODAL_DESCRIPTION} <strong>{selectedOrganization}</strong>
          </div>
          
          {error && (
            <Alert severity="error" style={{ marginTop: '16px', marginBottom: '16px' }}>
              {error}
            </Alert>
          )}
          
          <div className={classes.formField}>
            <div className={classes.modalDropdown}>
              {renderModalContent()}            
            </div>
          </div>
          
          <div className={classes.modalActions}>
            <Button onClick={handleCloseCreateModal} color="default">
              Cancel
            </Button>
            <Button disabled={!selectedHiMarleyUser || isSubmittingCreateUser} onClick={handleSubmitCreateUser} color="primary" variant="contained">
              Submit
            </Button>
          </div>
        </Box>
      </Modal>
    )
}

export default CreateAliasUserModal